import React, { useCallback, useContext, useState } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import dayjs from 'dayjs';

import { EMPTY_ID } from '@totem/components/common/reference/ReferenceSelector';
import BillingContext from '@totem/components/ticketing/billing/billingContext';
import UnbilledSelectedTable from '@totem/components/ticketing/billing/unbilledSelectedTable';
import { BillingEntry } from '@totem/components/ticketing/ticketing';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { TICKETS_ENDPOINT } from '@totem/utilities/endpoints';
import { CheckResponseShowError } from '@totem/utilities/responseUtilities';
const BillinDialog = () => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const {
    selectedUnbilled,
    action,
    onAction,
    clearSelectedUnbilled,
    selectedOrganizationId,
  } = useContext(BillingContext);
  const [isSending, setIsSending] = useState(false);
  const [billingId, setBillingId] = useState<string>('');
  const [form] = Form.useForm();
  const sendBilling = useCallback(
    async (payload: BillingEntry) => {
      if (!isSending) {
        fetch(`${TICKETS_ENDPOINT}/billing`, {
          method: 'POST',
          headers: new Headers({
            Authorization: `Bearer ${getApiToken()}`,
          }),
          body: JSON.stringify(payload),
        }).then((res) => {
          setIsSending(false);
          const success = CheckResponseShowError(res);
          if (success) {
            form.resetFields();

            clearSelectedUnbilled();

            onAction('refresh', '');
          }
        });
      }
    }, // End async
    [],
  );
  const handleSubmit = () => {
    form.validateFields().then(() => {
      const payload: BillingEntry = {
        id: EMPTY_ID,
        organizationId: selectedOrganizationId,
        billingId,
        timeEntryIds: selectedUnbilled.map((chk) => chk.timeEntry.id),
        createdByType: 'USER',
        createdByName: userProfile.email,
        createdById: userProfile.id,
        createdAt: dayjs().toISOString(),
      };
      sendBilling(payload);
    });
  };
  return (
    <Modal
      open={action === 'create-billing'}
      width={'50%'}
      title="Create Billing"
      onCancel={() => {
        onAction('', '');
      }}
      onOk={handleSubmit}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            onAction('', '');
          }}
        >
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          Submit
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Sales Order Number"
          name="salesOrderNumber"
          initialValue={billingId}
          rules={[
            { required: true, message: 'Please enter sales order number' },
          ]}
        >
          <Input
            value={billingId}
            onChange={(event) => setBillingId(event.target.value)}
          />
        </Form.Item>
      </Form>
      <UnbilledSelectedTable />
    </Modal>
  );
};
export default BillinDialog;
